import React from "react";
import { formatCategoryName } from "../../../../utils/chartUtil";

export const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        const category = payload[0]?.payload?.category;
        const formattedCategory = category ? formatCategoryName(category) : "";

        return (
            <div className="bg-white p-4 border border-gray-200 rounded-lg shadow-lg">
                <p className="font-semibold mb-1">{formattedCategory}</p>
                <p className="text-sm text-gray-600 mb-2">{label}</p>
                {payload.map((entry) => (
                    <p key={entry.name} style={{ color: entry.color }}>
                        {`${entry.name}: ${entry.value}`}
                    </p>
                ))}
            </div>
        );
    }
    return null;
};
